import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.gastosVsBancos.agregar', {
    url: '/agregar',
    data: {
      title: 'Agregar',
    },
    resolve: {
      Data: () =>  ({
          Folio: null,
          Banco_ID: undefined,
          Fecha: undefined,
          Banco_Numero_Cuenta: undefined,
          Banco_Forma_Pago: undefined,
          Banco_Referencia: '',
          Importe: undefined,
          Servicios: [],
        }),
      Services: () => [],
    },
    template,
    controllerAs: 'ctrl',
    controller: 'FinanzasGastosvsbancosController',
  });

  $stateProvider.state('finances.gastosVsBancos.editar', {
    url: '/editar/:folio',
    resolve: {
      folio: ($stateParams) => $stateParams['folio'],
      Data: (FinanzasGastosVsBancos, $stateParams) => FinanzasGastosVsBancos.$get($stateParams['folio']),
      Services: (Data, FinanzasGastosVsBancos, $q) => {
        Data.Servicios.push('000001U5');
        var services = Data.Servicios.map(function (folio) {
          return FinanzasGastosVsBancos.$getService(folio).catch(function () {
            return false;
          });
        });
        return $q.all(services).then(function (services) {
          return services.filter(function (service) {
            return service;
          });
        });
      },
    },
    data: {
      title: '{{folio}}',
    },
    views: {
      '@': {
        template,
        controllerAs: 'ctrl',
        controller: 'FinanzasGastosvsbancosController',
      },
    },
  });
})

function FinanzasGastosvsbancosController (Data, Services, Catalogs, FinanzasGastosVsBancos, $notify, $state, $scope, $dialog, $q) {
  var ctrl = this;
  ctrl.data = angular.copy(Data);
  ctrl.services = angular.copy(Services);
  ctrl.updating = false;
  ctrl.loading = false;
  ctrl.options = {
    total: undefined,
    difference: undefined,
  };

  $scope.$watch('ctrl.data.Importe', function () {
    ctrl.$calculate();
  });

  ctrl.catalogos = {
    Formas_Pago: Catalogs.Formas_Pago.$select(),
    Bancos: Catalogs.Bancos.$select(),
    Bancos_Cuentas: Catalogs.Bancos_Cuentas.$select(),
    Movimientos: Catalogs.Movimientos,
    Empresas: Catalogs.Empresas,
  };

  ctrl.$removeService = function (index) {
    ctrl.services.splice(index, 1);
    ctrl.$calculate();
    if (ctrl['Form']) {
      ctrl['Form'].$setDirty();
    }
  };

  ctrl.$addService = function (folio) {
    var reg = /^\d+$/;
    folio = folio || prompt('Search for folio');
    if (folio) {
      if (!reg.test(folio)) {
        $notify.error('Folio no válido. Solo números son permitidos', folio);
      } else if (folio.length > 10) {
        $notify.error('El folio debe de tener 10 números o menos');
      } else {
        ctrl.loading = true;
        FinanzasGastosVsBancos.$getService(folio).then(function (service) {
          if (service) {
            service.expanded = true;
            ctrl.services.push(service);
            ctrl.$calculate();
            if (ctrl['Form']) {
              ctrl['Form'].$setDirty();
            }
          } else {
            $notify.error('No existe un servicio con folio %s', folio)
          }
        }).catch(function (error) {
          $notify.error(error);
        }).finally(function () {
          ctrl.loading = false;
        });
      }
    }
  };

  ctrl.$calculate = function () {
    if (ctrl.services && ctrl.services.length > 0) {
      ctrl.options.total = 0;
      angular.forEach(ctrl.services, function (Service) {
        ctrl.options.total = Number((ctrl.options.total + Service.Importe).toFixed(2));
      });
      ctrl.options.difference = Math.abs(Number((ctrl.data.Importe - ctrl.options.total).toFixed(2)));
    } else {
      ctrl.options.total = ctrl.options.difference = undefined;
    }
  };

  ctrl.$save = function () {
    if (ctrl.services.length === 0) {
      alert('Es necesario especificar al menos un servicio.');
      return;
    }

    var confirm = ctrl.data.Importe !== ctrl.options.total
      ? $dialog.confirm('La suma de los servicios seleccionados no coincide con el importe especificado. ¿Desea continuar?')
      : $q.when();

    confirm.then(function () {
      ctrl.data.Servicios = ctrl.services.map(function (service) {
        return service.Folio;
      });

      ctrl.updating = true;

      return FinanzasGastosVsBancos.$add(ctrl.data.Folio, ctrl.data).catch(function (error) {
        $notify.error(error);
      }).finally(function () {
        ctrl.updating = false;
      });
    });
  };

  ctrl.$reset = function () {
    ctrl.data = angular.copy(Data);
    ctrl.services = angular.copy(Services);
    if (ctrl['Form']) {
      ctrl['Form'].$setPristine();
    }
    ctrl.$calculate();
  };

  ctrl.$edit = function (reference) {
    if (ctrl['Form']) {
      ctrl['Form'].$setPristine();
    }
    $state.go('^.editar', {folio: reference['Folio']});
  };
}

module.controller('FinanzasGastosvsbancosController', FinanzasGastosvsbancosController)



// WEBPACK FOOTER //
// ./src/finanzas/_/gastosVsBancos/editar/finances-gastosVsBancos-editar.js